import { useMatch } from "react-router-dom";

/**
 * This hook checks if the current route is a tariff change route.
 *
 * @returns {boolean} Whether the current route is a tariff change route.
 */
export const useIsTariffChange = () =>
  !!useMatch("portal/cockpit/manage/tariff/change/*");
